module.exports = __webpack_public_path__ + "img/icon_submenu16.ee6b3f8d.svg";